import {technicalIndicators, TechnicalIndicators} from "./technical-indicators/TechnicalIndicatorsComponent";
import {
    TechnicalStatisticsChart,
    technicalStatisticsChart
} from "./technical-statistics-chart/TechnicalStatisticsChartComponent";
import {keyStats, KeyStats} from "./key-stats/TechnicalIndicatorsKeyStatsComponent";

export default angular.module("tfApp.trading-systems.components", [])
                      .component(TechnicalIndicators, technicalIndicators())
                      .component(TechnicalStatisticsChart, technicalStatisticsChart())
                      .component(KeyStats, keyStats())
                      .name;
